function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 11H19.01",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 7,
  width: 17,
  height: 13,
  rx: 1,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3038 7L18.0114 4.21754C17.9537 3.66828 17.4616 3.26982 16.9124 3.32754L1.99452 4.89547C1.44526 4.9532 1.0468 5.44526 1.10453 5.99452L2.25434 16.9343C2.31207 17.4835 2.80413 17.882 3.35339 17.8243L6 17.5461",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 15L10 11L16 17",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 18.5L18.5 14L15.5 17",
  strokeWidth: 2,
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0V0Z",
  fill: "white"
})));

function SvgImages(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-images",
    ref: svgRef
  }, props), _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.18e879f9.svg";
export { ForwardRef as ReactComponent };